import {
  TEditBeneficiary,
  IBeneficiary,
  IFilterBeneficiary,
  TCreateAndEditBeneficiary,
  TMetaBeneficiary,
} from '@/features/beneficiaries/store/models/beneficiary.model';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { get } from '@/services/FetchServices';

export class BeneficiaryService {
  static queryKey = 'Beneficiary';

  static getBeneficiaries = async (
    filter?: IFilterBeneficiary,
  ): Promise<{ beneficiaries: IBeneficiary[]; meta: TMetaBeneficiary }> => {
    try {
      const config = getStaticDashboardConfig();
      const search: IFilterBeneficiary = {
        ...filter,
        pageNumber: filter?.pageNumber ?? 1,
      };
      const path = '/v1/beneficiaries?';
      const url = new URL(`${config.api.baseUrl}${path}`);
      if (search) {
        Object.keys(search).forEach((key) => url.searchParams.append(key, search[key]));
      }

      return await get(
        { url: url.toString(), searchParams: url.searchParams, action: this.queryKey },
        { shouldSkipEncryption: true, isSingle: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };

  static createBeneficiary = async (beneficiaryRequest: TCreateAndEditBeneficiary): Promise<IBeneficiary> => {
    try {
      const config = getStaticDashboardConfig();

      const [beneficiary] = await get<IBeneficiary>(
        { url: `${config.api.baseUrl}/v1/beneficiaries`, method: 'POST', body: beneficiaryRequest },
        { shouldSkipEncryption: true },
      );

      return beneficiary;
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static editBeneficiary = async (beneficiaryRequest: TEditBeneficiary): Promise<IBeneficiary> => {
    try {
      const config = getStaticDashboardConfig();

      const { id, userId, ...rest } = beneficiaryRequest;

      const [beneficiary] = await get<IBeneficiary>(
        { url: `${config.api.baseUrl}/v1/beneficiaries/${id}`, method: 'PUT', body: rest, action: this.queryKey },
        { shouldSkipEncryption: true },
      );

      return beneficiary;
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
